module.exports = __webpack_public_path__ + "files/581e77a486d52d7f26a7d013ec2d0445.png";